import React from 'react';
import {
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';
import { useTestAgent } from '../hooks/useFAQApi';
import { AgentTestResponse } from '../types/faq.types';

interface AgentTesterProps {
  question: string;
}

export const AgentTester: React.FC = () => {
  const [testingQuestion, setTestingQuestion] = React.useState('');
  const [testResult, setTestResult] = React.useState<AgentTestResponse | null>(null);
  const { mutateAsync: testAgent, isPending: testing } = useTestAgent();

  const handleTestAgent = async () => {
    if (!testingQuestion.trim()) return;

    try {
      const result = await testAgent(testingQuestion);
      setTestResult(result);
    } catch (error) {
      // Error handled by the mutation
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Test Agent FAQ
      </Typography>

      <Box display="flex" flexDirection="column" gap={2}>
        {/* Test Input */}
        <input
          type="text"
          value={testingQuestion}
          onChange={(e) => setTestingQuestion(e.target.value)}
          placeholder="Type your question..."
          disabled={testing}
        />

        {/* Test Button */}
        <button onClick={handleTestAgent} disabled={testing}>
          {testing ? 'Testing...' : 'Test'}
        </button>

        {/* Loading Spinner */}
        {testing && <CircularProgress />}

        {/* Result */}
        {testResult && (
          <Box>
            <Typography variant="subtitle1">Result:</Typography>
            <Typography variant="body2">Answer: {testResult.answer}</Typography>
            <Typography variant="body2">Confidence: {testResult.confidence}</Typography>
            <Typography variant="body2">Response Time: {testResult.response_time}ms</Typography>
          </Box>
        )}

        {/* Error handling could be added here */}
      </Box>
    </Paper>
  );
};
